import React from "react";
import "./Header.scss";
import ArrowSvg from "../../../../../prod/images/_arrow.svg?react";
import { CatalogueHeaderItemsData } from "../../../../api/headerApi.types";

interface CatalogueMegaMenuSubItemProps {
  item: CatalogueHeaderItemsData;
}

export const CatalogueMegaMenuSubItem: React.FC<
  CatalogueMegaMenuSubItemProps
> = ({ item }) => {
  return (
    <li className="editorial-block">
      <div className="editorial-block-main">
        <span className="editorial-block-title">{item.linkTitle}</span>
      </div>
      <ul className="editorial-block-content">
        {item.subItems.map((sub) => (
          <li className="border-b border-primary hover:underline py-1">
            <a className="text-primary" href={sub.linkUrl}>
              {sub.linkTitle}
            </a>
          </li>
        ))}
      </ul>
    </li>
  );
};
